import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type JSX, type PropsWithChildren } from 'react';
import { AuthProvider, createQueryClient } from '@invite/app-core';

interface ProvidersProps {
  client?: QueryClient;
  onSessionExpired?: () => void;
}

/** Language is provided above `App` (main.tsx), so tests can set the language themselves. */
export const Providers = ({
  children,
  client,
  onSessionExpired
}: PropsWithChildren<ProvidersProps>): JSX.Element => {
  const [fallback] = useState(() => createQueryClient());
  return (
    <QueryClientProvider client={client ?? fallback}>
      <AuthProvider onSessionExpired={onSessionExpired}>{children}</AuthProvider>
    </QueryClientProvider>
  );
};
